// TODO: evaluate if this is useful
export enum NgWizardErrorType {
  NO_WIZARD_ROUTE,
  NO_CHILD_ROUTES,
  NO_WS_INTERFACE,
}
